<div *ngFor="let banner of banners;let i = index">
    <div *ngIf="isBanner && maintenanceBanner" class="banner-wrapper" fxLayout="row">
        <div fxFlex="98" fxFlex.sm="95" fxFlex.xs="90">
            {{banner}}
        </div>
        <div fxFlex="2" fxFlex.sm="5" fxFlex.xs="10">
            <button mat-icon-button class="banner-close-button" (click)="banners.splice(i, 1)">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>

